import { useMutation } from 'react-query';
import { useState } from 'react';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

interface IProps {
    file: File,
    billId: string | undefined
}
export const useUploadAttachment = () => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();
  const [abortController, setAbortController] = useState(new AbortController());

  const cancelReq = () => {
    abortController.abort();
    setTimeout(() => {
      // ** In case to keep using this mutation after cancel, we must reset the signal provider */
      setAbortController(new AbortController());
    }, 1000);
  };

  return {
    cancelReq,
    mutation: useMutation(
      'useUploadAttachment',
      async ({ file, billId }: IProps) => {
        const formData = new FormData();
        formData.append('document', file);
        const res = await httpService.post(
          `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${billId}/document/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            signal: abortController.signal,
          },
        );
        return res.data;
      },
    ),
  };
};
